import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';
import classnames from 'classnames';

import BAlert, { bAlertType } from '../general/BAlert';
import FeatureFlag from '../general/FeatureFlag';
import { translate as t } from '../../lib/I18n';
import PassengerRailcard from '../../records/PassengerRailcard';
import PassengersForm from '../../records/search/PassengersForm';

import Icon from '../general/Icon';
import Railcard from './Railcard';
import SectionErrors from './SectionErrors';
import PureRenderComponent from '../PureRenderComponent';

class Railcards extends PureRenderComponent {

    static propTypes = {
        railcards: PropTypes.instanceOf(List).isRequired,
        adults: PropTypes.number.isRequired,
        children: PropTypes.number.isRequired,
        className: PropTypes.string,
        enableRemoving: PropTypes.bool,
        hideExpiryNotice: PropTypes.bool,
        onRailcardsChange: PropTypes.func,
        Form: PropTypes.func
    };

    static defaultProps = {
        className: '',
        enableRemoving: false,
        hideExpiryNotice: false,
        onRailcardsChange: _.noop,
        Form: PassengersForm
    };

    _validate () {
        const { railcards, adults, children } = this.props;
        const form = new this.props.Form({ railcards, adults, children });

        const error = form.getError('railcards');
        if (error) {
            return [ error ];
        }
        return [];
    }

    _addRailcard = () => {
        const passengerRailcard = new PassengerRailcard();
        const railcards = this.props.railcards.push(passengerRailcard);
        this.props.onRailcardsChange(railcards);
    };

    _updateRailcard = key => railcard => {
        const railcards = this.props.railcards.set(key, railcard);
        this.props.onRailcardsChange(railcards);
    };

    _removeRailcard = key => () => {
        const { railcards } = this.props;
        this.props.onRailcardsChange(railcards.delete(key));
    }

    _removeLastRailcard = () => {
        const railcards = this.props.railcards.pop();
        this.props.onRailcardsChange(railcards);
    };

    _isAddDisabled () {
        return !!this._validate().length;
    }

    _renderRailcardExpiryNotice = () => {
        const { hideExpiryNotice, railcards } = this.props;

        return railcards.size > 0 && (
            <FeatureFlag name="showRailcardExpiryInfo" disabled={ hideExpiryNotice }>
                <BAlert type={ bAlertType.INFO } className="margin-bottom--sm">
                    <Icon icon="warning b-alert__icon b-alert__icon--multiline" />
                    {t('boooking.railcards.checkExpiry')}
                </BAlert>
            </FeatureFlag>
        );
    }

    _renderRemoveButton ({ railcards }) {
        return railcards.size > 0 ? (
            <Button className="btn-sm" onClick={ this._removeLastRailcard }>
                <Icon icon="remove" />{ t('booking.railcards.remove') }
            </Button>
        ) : null;
    }

    render () {
        const { adults, children, className, enableRemoving, Form, railcards } = this.props;

        const errors = this._validate();

        return (
            <div className={ classnames('railcards', className) }>

                <Button className="btn-sm" onClick={ this._addRailcard } disabled={ this._isAddDisabled() }>
                    <Icon icon="add" />{ t('booking.railcards.add') }
                </Button>

                <ul className="list-unstyled railcards__list">
                    { railcards.map((passengerRailcard, key) => {

                        /* constructs an array of relevant errors for each specific railcard: */
                        const railcardSpecificForm = new Form({ adults, children, railcards: List.of(passengerRailcard) });
                        const railcardSpecificErrors = railcardSpecificForm.getValidationSummaryArray();
                        if (railcards.size > 1 && errors.includes(t('alertmessage.form.moreRailcardsThanPassengers'))) {
                            railcardSpecificErrors.push(t('alertmessage.form.moreRailcardsThanPassengers'));
                        }

                        return (
                            <Railcard
                                key={ key }
                                code={ passengerRailcard.code }
                                enableRemoving={ enableRemoving }
                                quantity={ passengerRailcard.quantity }
                                onChange={ this._updateRailcard(key) }
                                onDelete={ this._removeRailcard(key) }
                                error={ _.uniq(railcardSpecificErrors).join('. ') }
                            />
                        );
                    }) }
                </ul>

                { this._renderRailcardExpiryNotice() }

                { !enableRemoving && this._renderRemoveButton(this.props) }
                { errors.length > 0 &&
                    <SectionErrors errors={ errors } /> }
            </div>
        );
    }

}

export default Railcards;



// WEBPACK FOOTER //
// ./src/components/search/Railcards.js